import { Box, Text, IconButton } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { CartContext } from '../../../../context/cart';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';

const SlotCard = ({ date, isBooked }) => {
  const { setOrderDetail, orderDetail } = useContext(CartContext);
  const dateString = date?.date?.toString();
  const dayString = date?.day?.toString();
  const isDisabled = isBooked;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDir: 'column',
        alignItems: 'center',
        boxShadow: ' 1px -1px 10px 1px rgba(0, 0, 0, 0.1)',
        minWidth: '125px',
        borderRadius: '10px',
        overflow: 'hidden',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.7 : 1,
        border: `2px solid ${
          orderDetail?.appointmentDate === date?.date?.toString()
            ? 'darkgreen'
            : 'transparent'
        }`,
      }}
      onClick={() => {
        if (isDisabled) return;
        setOrderDetail(orderDetail => ({
          ...orderDetail,
          appointmentDate: dateString,
          appointmentTime: '',
        }))
      }}
    >
      <Text
        sx={{
          fontWeight: 600,
          color: isDisabled ? 'gray.500' : 'black',
        }}
      >
        {dateString}
      </Text>
      <Text color={isDisabled ? 'gray.400' : 'inherit'}>{dayString}</Text>
      <Box
        sx={{
          width: '100%',
          bgColor: isDisabled ? 'gray.100' : 'rgb(207, 255, 207)',
          mt: '10px',
          borderTop: '2px solid rgba(0, 0, 0, 0.1)',
        }}
      >
        <Text
          sx={{
            color: isDisabled ? 'gray.600' : 'darkgreen',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
          {isDisabled ? 'Booked' : 'Available'}
        </Text>
      </Box>
    </Box>
  );
};

export const SelectDate = () => {
  const [dates, setDates] = useState([]);
  const scrollRef = React.useRef(null);
  const { orderDetail, setOrderDetail } = useContext(CartContext);

  useEffect(() => {
    function getFutureDatesWithDay(numDays) {
      let currentDate = new Date();
      let futureDatesWithDay = [];

      for (let i = 0; i < numDays; i++) {
        let formattedDate = `${currentDate
          .getDate()
          .toString()
          .padStart(2, '0')}-${(currentDate.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${currentDate.getFullYear()}`;

        let dayOfWeek = currentDate.toLocaleDateString('en-US', {
          weekday: 'long',
        });

        futureDatesWithDay.push({ date: formattedDate, day: dayOfWeek });
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return futureDatesWithDay;
    }

    const datesGenerated = getFutureDatesWithDay(14);
    setDates(() => datesGenerated);

    // Auto-select the first date if none is selected
    if (!orderDetail?.appointmentDate && datesGenerated.length > 0) {
      setOrderDetail(prev => ({
        ...prev,
        appointmentDate: datesGenerated[0].date
      }));
    }
  }, [orderDetail?.appointmentDate, setOrderDetail]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - 400 : scrollLeft + 400;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDir: 'column',
        alignItems: 'flex-start',
        gap: '20px',
        maxWidth: '100%',
        position: 'relative',
      }}
    >
      <Text
        sx={{
          color: 'black',
          fontSize: '18px',
          fontWeight: 600,
        }}
      >
        Select Date
      </Text>
      
      <Box position="relative" width="100%" px={[0, "10px"]}>
        {/* Navigation Arrows */}
        <IconButton
          aria-label="Scroll Left"
          icon={<BiChevronLeft size="30px" />}
          position="absolute"
          left={["-10px", "-20px"]}
          top="50%"
          transform="translateY(-50%)"
          zIndex={20}
          onClick={() => scroll('left')}
          borderRadius="full"
          colorScheme="teal"
          bg="teal.500"
          color="white"
          boxShadow="0 4px 12px rgba(0, 0, 0, 0.15)"
          _hover={{ bg: 'teal.600', transform: 'translateY(-50%) scale(1.1)' }}
          _active={{ transform: 'translateY(-50%) scale(0.95)' }}
          size="md"
          display={['none', 'flex']}
        />
        <IconButton
          aria-label="Scroll Right"
          icon={<BiChevronRight size="30px" />}
          position="absolute"
          right={["-10px", "-20px"]}
          top="50%"
          transform="translateY(-50%)"
          zIndex={20}
          onClick={() => scroll('right')}
          borderRadius="full"
          colorScheme="teal"
          bg="teal.500"
          color="white"
          boxShadow="0 4px 12px rgba(0, 0, 0, 0.15)"
          _hover={{ bg: 'teal.600', transform: 'translateY(-50%) scale(1.1)' }}
          _active={{ transform: 'translateY(-50%) scale(0.95)' }}
          size="md"
          display={['none', 'flex']}
        />

        <Box 
          ref={scrollRef}
          display={'flex'} 
          gap={'15px'} 
          overflowX={'scroll'} 
          maxWidth={'100%'}
          py={2}
          px={1}
          sx={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            scrollBehavior: 'smooth',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {dates?.map((date, ind) => (
            <SlotCard date={date} key={ind} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
